import ApiError from '../../../../entities/api-error/ApiError'
import { AvailableDays } from '../../../../entities/available-days/AvailableDays'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestAvailableDays {
  type: DashboardActionTypes.REQUEST_AVAILABLE_DAYS;
}

export function requestAvailableDays(): RequestAvailableDays {
  return {
    type: DashboardActionTypes.REQUEST_AVAILABLE_DAYS,
  }
}

export interface RequestAvailableDaysSuccess {
  type: DashboardActionTypes.REQUEST_AVAILABLE_DAYS_SUCCESS;
  payload: {
    availableDays: AvailableDays;
  }
}

export function requestAvailableDaysSuccess({
  availableDays,
}: RequestAvailableDaysSuccess['payload']): RequestAvailableDaysSuccess {

  return {
    type: DashboardActionTypes.REQUEST_AVAILABLE_DAYS_SUCCESS,
    payload: {
      availableDays,
    },
  }
}

export interface RequestAvailableDaysFailure {
  type: DashboardActionTypes.REQUEST_AVAILABLE_DAYS_FAILURE;
  payload: {
    error:  ApiError;
  }
}

export function requestAvailableDaysFailure({
 error,
}: RequestAvailableDaysFailure['payload']): RequestAvailableDaysFailure {

  return {
    type: DashboardActionTypes.REQUEST_AVAILABLE_DAYS_FAILURE,
    payload: {
      error,
    },
  }
}
